import React from 'react';
import PropTypes from 'prop-types';
import './Section.css';

export const Section = ({ title, children }) => (
  <div className="section">
    <div className="section-header">
      {title}
    </div>
    <div className="section-body">
      {children}
    </div>
  </div>
);

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

Section.defaultProps = {
  children: [],
};

export const SectionRow = ({ children }) => (
  <div className="section-row">
    {children}
  </div>
);

SectionRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

SectionRow.defaultProps = {
  children: [],
};

export const SectionText = ({ children }) => (
  <div className="section-text">{children}</div>
);

SectionText.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

SectionText.defaultProps = {
  children: [],
};
